module.exports = __webpack_public_path__ + "img/gusd.471ea5d9.svg";